module.exports = __webpack_public_path__ + "static/media/info-bulb.7aefe6f1.svg";